import { useContext } from 'react';

import { ExamCourseContext } from './exam-course-provider';

function useExamCourse() {
  const context = useContext(ExamCourseContext);

  if (!context) {
    throw new Error('useExamCourse must be used within a ExamCourseProvider');
  }

  return context;
}

export { useExamCourse };
